import { render, staticRenderFns } from "./GameScreen.vue?vue&type=template&id=6e7d7b80&scoped=true&"
import script from "./GameScreen.vue?vue&type=script&lang=ts&"
export * from "./GameScreen.vue?vue&type=script&lang=ts&"
import style0 from "./GameScreen.vue?vue&type=style&index=0&id=6e7d7b80&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7d7b80",
  null
  
)

export default component.exports